// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompareModal_modal__oRIQp .ant-modal-content {
  border-radius: 20px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 24px 32px;
}
.CompareModal_modal__oRIQp .ant-modal-header {
  background: transparent;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding-bottom: 16px;
}
.CompareModal_modal__oRIQp .ant-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--accent-color);
  letter-spacing: -0.5px;
}
.CompareModal_modal__oRIQp .ant-tabs-nav::before {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.CompareModal_modal__oRIQp .ant-tabs-tab {
  padding: 12px 16px;
  font-weight: 600;
  color: var(--grey-text);
}
.CompareModal_modal__oRIQp .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: var(--accent-color) !important;
}
.CompareModal_modal__oRIQp .ant-tabs-ink-bar {
  background: var(--accent-color);
  height: 3px;
  border-radius: 3px 3px 0 0;
}

.CompareModal_content__zOa2w {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.CompareModal_description__kcki6 {
  font-size: 14px;
  color: var(--grey-text);
  margin-bottom: 8px;
}

.CompareModal_chartWrapper__a8xtB {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.CompareModal_pieControls__zPR7Z {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 4px;
}

.CompareModal_controlLabel__pdOvU {
  font-size: 13px;
  font-weight: 600;
  color: var(--grey-text);
}

.CompareModal_metricGrid__I0okb {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.CompareModal_metricBtn__RhwzE {
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-1);
  cursor: pointer;
  transition: all 0.2s;
}
.CompareModal_metricBtn__RhwzE:hover {
  background: #f5f7fa;
  border-color: var(--accent-color-medium);
}
.CompareModal_metricBtn__RhwzE.CompareModal_active__vWnpa {
  background: var(--accent-color);
  color: #fff;
  border-color: var(--accent-color);
  box-shadow: 0 4px 8px rgba(30, 58, 95, 0.2);
}

.CompareModal_chartContainer__0Y4t0 {
  height: 400px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.CompareModal_tabs__ZbgmM {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Benchmarking/Components/CompareModal/CompareModal.module.scss"],"names":[],"mappings":"AAEI;EACE,mBAAA;EACA,gBAAA;EACA,qCAAA;EACA,2BAAA;EACA,0CAAA;EACA,kBAAA;AADN;AAII;EACE,uBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oBAAA;AAFN;AAKI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,sBAAA;AAHN;AAMI;EACE,4CAAA;AAJN;AAOI;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;AALN;AAOM;EACE,qCAAA;AALR;AASI;EACE,+BAAA;EACA,WAAA;EACA,0BAAA;AAPN;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AATF;;AAYA;EACE,eAAA;EACA,uBAAA;EACA,kBAAA;AATF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AATF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AATF;;AAYA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AATF;;AAYA;EACE,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;AATF;AAWE;EACE,mBAAA;EACA,wCAAA;AATJ;AAYE;EACE,+BAAA;EACA,WAAA;EACA,iCAAA;EACA,2CAAA;AAVJ;;AAcA;EACE,aAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,qCAAA;AAXF;;AAcA;EACE,eAAA;AAXF","sourcesContent":[".modal {\n  :global {\n    .ant-modal-content {\n      border-radius: 20px;\n      overflow: hidden;\n      background: rgba(255, 255, 255, 0.95);\n      backdrop-filter: blur(20px);\n      border: 1px solid rgba(255, 255, 255, 0.3);\n      padding: 24px 32px;\n    }\n\n    .ant-modal-header {\n      background: transparent;\n      margin-bottom: 24px;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n      padding-bottom: 16px;\n    }\n\n    .ant-modal-title {\n      font-size: 22px;\n      font-weight: 700;\n      color: var(--accent-color);\n      letter-spacing: -0.5px;\n    }\n\n    .ant-tabs-nav::before {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n    }\n\n    .ant-tabs-tab {\n      padding: 12px 16px;\n      font-weight: 600;\n      color: var(--grey-text);\n\n      &-active .ant-tabs-tab-btn {\n        color: var(--accent-color) !important;\n      }\n    }\n\n    .ant-tabs-ink-bar {\n      background: var(--accent-color);\n      height: 3px;\n      border-radius: 3px 3px 0 0;\n    }\n  }\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.description {\n  font-size: 14px;\n  color: var(--grey-text);\n  margin-bottom: 8px;\n}\n\n.chartWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.pieControls {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 0 4px;\n}\n\n.controlLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--grey-text);\n}\n\n.metricGrid {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.metricBtn {\n  padding: 6px 12px;\n  border-radius: 8px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-1);\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    background: #f5f7fa;\n    border-color: var(--accent-color-medium);\n  }\n\n  &.active {\n    background: var(--accent-color);\n    color: #fff;\n    border-color: var(--accent-color);\n    box-shadow: 0 4px 8px rgba(30, 58, 95, 0.2);\n  }\n}\n\n.chartContainer {\n  height: 400px;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.03);\n}\n\n.tabs {\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `CompareModal_modal__oRIQp`,
	"content": `CompareModal_content__zOa2w`,
	"description": `CompareModal_description__kcki6`,
	"chartWrapper": `CompareModal_chartWrapper__a8xtB`,
	"pieControls": `CompareModal_pieControls__zPR7Z`,
	"controlLabel": `CompareModal_controlLabel__pdOvU`,
	"metricGrid": `CompareModal_metricGrid__I0okb`,
	"metricBtn": `CompareModal_metricBtn__RhwzE`,
	"active": `CompareModal_active__vWnpa`,
	"chartContainer": `CompareModal_chartContainer__0Y4t0`,
	"tabs": `CompareModal_tabs__ZbgmM`
};
export default ___CSS_LOADER_EXPORT___;
